import * as React from "react";

import { PrimaryButtonColorProps } from "./PrimaryButton";
import PrimaryButtonWhite from "./PrimaryButtonWhite";
import "./PrimaryButtonWhiteFreeTheme.scss";

type Props = PrimaryButtonColorProps;

export default class PrimaryButtonWhiteFreeTheme extends React.PureComponent<Props> {
  render() {
    return (
      <PrimaryButtonWhite
        className="PrimaryButtonWhiteFreeTheme"
        textClassName="PrimaryButtonWhiteFreeTheme__text"
        {...this.props}
      />
    );
  }
}
